(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    class HyghFilter extends HTMLElement {
    constructor() {
      super()
    }
    connectedCallback() {
      this.filterLabelWrapper = this.querySelector(".filters-label__wrapper");
      this.filterLabelWrapper.addEventListener("click", (e) => {this.selectCategory(e)});
      this.filterLabelWrapper.addEventListener("keydown", (e) => {
        if ((e.key === "Enter" || e.key === " ") && e.target.dataset.paramName) {
          e.preventDefault();
          e.target.click();
        }
      });
    }
    disconnectedCallback() {
      this.filterLabelWrapper.removeEventListener("click", (e) => {this.selectCategory(e)});
    }
    selectCategory(e) {
      const target = e.target;
      if (e.target.dataset.paramName) {
        if (target.classList.contains("filters-label__selected")) return;
        const currentCategory = this.querySelector(".filters-label__selected");
        const currentFilters = document.getElementById(currentCategory.dataset.paramName);
  
        currentCategory.classList.remove("filters-label__selected");
        currentCategory.classList.add("animation-underline");
        currentCategory.setAttribute("aria-expanded", "false");
        currentFilters.classList.add("hidden");

        const targetFilterOptions = document.getElementById(target.dataset.paramName);
        target.classList.add("filters-label__selected");
        target.classList.remove("animation-underline");
        target.setAttribute("aria-expanded", "true");
        targetFilterOptions.classList.remove("hidden");
      }
    }
  }
  customElements.define("hygh-filter", HyghFilter);
  } catch(e) { console.error(e); }
})();

})();
